export const REQUEST_LOADING = "API_REQUEST_LOADING";
export const SEND_API_REQUEST_SUCCESS = "SEND_API_REQUEST_SUCCESS";
export const SEND_API_REQUEST_FAIL = "SEND_API_REQUEST_FAIL";
export const GET_CLASSISUPPLIER_REQUEST = "GET_CLASSISUPPLIER_REQUEST";
export const SEND_CLASSISUPPLIER_REQUEST_SUCCESS =
  "SEND_CLASSISUPPLIER_REQUEST_SUCCESS";
export const SEND_CLASSISUPPLIER_REQUEST_FAIL =
  "SEND_CLASSISUPPLIER_REQUEST_FAIL";
export const REMOVE_REQUEST_DATA = "REMOVE_REQUEST_DATA";
